import png1 from "./1.jpg";
import png2 from "./2.jpg";
import png3 from "./3.jpg";
import png4 from "./4.jpg";
import png5 from "./5.jpg";
export const jtyh = [
  {
    name: "查找流水",
    msgList: [
      { msg: "登录交通银行APP->顶部搜索【交易明细清单】->选择【电子版】" },
      { imgs: [png1, png2] },
    ],
  },
  {
    name: "发送账单",
    msgList: [
            { msg: "选择【近1年】->点击【去开立】->填入专属邮箱【确认开立】" },
      { imgs: [png3, png4, png5] },
    ],
  },
  {
    name: "注意事项",
    msgList: [
      { msg: "时间选择【近1年】打开【展示我的完整账号/卡号】【展示我的证件类型、号码】【展示交易地点】【展示对方账户信息】" },
    ],
  },
];
